import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const CustomersDashboard = lazyWithRetry(() => import('../pages/CustomersDashboard.tsx'));
const CustomerDetailPage = lazyWithRetry(() => import('../pages/CustomerDetailPage.tsx'));

const customersDashboardNode = {
  component: CustomersDashboard,
} satisfies ComponentPage;

const customerDetailNode = {
  component: CustomerDetailPage,
} satisfies ComponentPage;


const customersCrmRoutes: ComponentOrMapping = {
  erp: {
    customers: {
      overview: customersDashboardNode,
      detail: {
        ':customerId': customerDetailNode,
      },
    },
  },
};

export default customersCrmRoutes;
